// @flow
import React, { useCallback } from 'react';
import useRating from '../../hooks/rating';
import usePod from '../../hooks/pods';
import useUser from '../../hooks/user';
import RatingDlg from '../../components/rating-dlg/RatingDlg';

export default function AppFeedback() {
	const [{ selectedPod } = {}] = usePod();
	const [{mobile} = {}] = useUser();
	const [rating, submitRating, toggleRatingDlg] = useRating();
	const { ratingDlgState = false, pod, type } = rating;

	const handleSubmitRating = useCallback(
		(ratingData) => {
			submitRating({
				...ratingData,
				type: type || 'overall_rating',
				user_id: mobile,
				location: pod || (selectedPod && selectedPod.vm_imei_id) || '',
			});
			toggleRatingDlg(false);
		},
		[mobile, pod, selectedPod, submitRating, toggleRatingDlg, type]
	);

	return (
		<section>
			<RatingDlg open={ratingDlgState} closeDialog={() => toggleRatingDlg(false)} submitRating={handleSubmitRating} />
		</section> 
	);
}
